import { deleteRecord, getAllRecords, putRecord } from "./db";
import { curatedWalks } from "@japangolmok/content";
export async function savedWalks() {
	return (
		await getAllRecords<{ id: string; savedAt: string }>("saved-walks")
	).flatMap((row) => {
		const walk = curatedWalks.find((w) => w.slug === row.id);
		return walk ? [walk] : [];
	});
}
export async function toggleSavedWalk(slug: string) {
	const rows = await savedWalks();
	if (rows.some((w) => w.slug === slug))
		await deleteRecord("saved-walks", slug);
	else
		await putRecord("saved-walks", {
			id: slug,
			savedAt: new Date().toISOString(),
		});
}
